import classNames from 'classnames';
import React, { JSX, ReactNode } from 'react';
import Button, { ButtonSize, ButtonVariant } from '../Button';
import { IconContext } from '@phosphor-icons/react';

export interface AlertProps {
  className?: string;
  type: 'warning' | 'danger' | 'notice' | 'success';
  icon?: ReactNode;
  buttonOnClick?: () => void;
  buttonText?: string;
  buttonStyle?: 'button' | 'link';
  children: React.ReactNode;
}

/**
 * Generate a Box to show a message about the user action or the current state
 */
export default function Alert({
  type,
  className,
  children,
  icon,
  buttonText,
  buttonOnClick,
  buttonStyle = 'button',
}: AlertProps): JSX.Element {
  return (
    <div
      className={classNames(
        'leading-5 mb-3 p-2 border-l-4 flex items-center gap-x-2 text-gray-700',
        {
          'bg-red-50 border-red-300 text-red-700': type === 'danger',
          'bg-orange-50 border-orange-300 text-orange-700': type === 'warning',
          'bg-blue-50 border-blue-300 text-blue-700': type === 'notice',
          'bg-green-50 border-green-300 text-green-700': type === 'success',
        },
        className,
      )}
    >
      {icon && <IconContext.Provider value={{ size: 15, className: 'w-[20px] shrink-0' }}>{icon}</IconContext.Provider>}
      <p>{children}</p>
      {buttonText && buttonOnClick && (
        <>
          {buttonStyle === 'button' && (
            <Button size={ButtonSize.Small} variant={ButtonVariant.Primary} onClick={buttonOnClick} className='ml-auto shrink-0'>
              {buttonText}
            </Button>
          )}
          {buttonStyle === 'link' && (
            <button
              onClick={buttonOnClick}
              className={classNames('ml-auto shrink-0 border-b', {
                'border-red-300': type === 'danger',
                'border-orange-300': type === 'warning',
                'border-blue-300': type === 'notice',
                'border-green-300': type === 'success',
              })}
            >
              {buttonText}
            </button>
          )}
        </>
      )}
    </div>
  );
}
